import { render, staticRenderFns } from "./customDetail.vue?vue&type=template&id=4e7fa856&scoped=true&"
import script from "./customDetail.vue?vue&type=script&lang=ts&"
export * from "./customDetail.vue?vue&type=script&lang=ts&"
import style0 from "./customDetail.vue?vue&type=style&index=0&id=4e7fa856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7fa856",
  null
  
)

export default component.exports